import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-opciones-registro',
  templateUrl: './opciones-registro.component.html',
  styleUrls: ['./opciones-registro.component.scss'],
  standalone: false
})
export class OpcionesRegistroComponent {

  constructor(private router: Router) { }

  irARegistroRapido(): void {
    console.log('🔵 Navegando a registro-corto...');
    this.router.navigate(['/registro-corto']).then(
      (success) => {
        console.log('✅ Navegación exitosa a registro-corto:', success);
      },
      (error) => {
        console.error('❌ Error al navegar a registro-corto:', error);
      }
    );
  }

  irARegistroCV(): void {
    console.log('🔵 Navegando a registro-cv...');
    this.router.navigate(['/registro-cv']).then(
      (success) => {
        console.log('✅ Navegación exitosa a registro-cv:', success);
      },
      (error) => {
        console.error('❌ Error al navegar a registro-cv:', error);
      }
    );
  }
}
